import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter.boolean('active', 'Active'),
    filter.options.store('organization_id', 'Organization', 'organizations').multi(true),
    filter.boolean('isSuperAdmin', 'Super Admin'),
    filter.boolean('isManagerAdmin', 'Manager admin'),
  ], [])
}
